const getMql = () => window.matchMedia('(max-width: 768px)');

export default getMql;
